<template>
	<h1>Resend Validation Email</h1>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
